export const cookieConsent = {
  init,
  edit,
  getConsentCookies,
  setConsentCookies
};

function getFdCc() {
  return window['fdCc'];
}

function init(
  options: {
    lang: string;
    restaurantName: string;
    logoUrl: string;
    cookiePolicyUrl: string;
  },
  callback: (selected: string[]) => void
) {
  if (!getFdCc()) {
    getScript(
      {
        url:
          'https://flipdish-cookie-consent.s3-eu-west-1.amazonaws.com/www/production/latest/fd-cc.js',
        timeout: 5000
      },
      () => {
        getFdCc().init(options, callback);
      }
    );
  } else {
    getFdCc().init(options, callback);
  }
}

function getConsentCookies(): [string] {
  if (!getFdCc()) {
    console.error('Not downloaded yet. Use init method first.');
  }
  return getFdCc().getConsentCookies();
}

function setConsentCookies(value) {
  if (!getFdCc()) {
    console.error('Not downloaded yet. Use init method first.');
  }
  getFdCc().setConsentCookies(value);
}

function edit() {
  if (!getFdCc()) {
    console.error('Not downloaded yet. Use init method first.');
  }
  getFdCc().edit();
}

function getScript(
  options: {
    url:
      | {
          src: string;
          type: string;
        }
      | string;
    timeout: number;
  },
  callback: () => void
) {
  let timeoutIdx;
  const scriptTag = document.createElement('script');

  scriptTag.type = 'text/' + (typeof options.url === 'string' ? 'javascript' : options.url.type);
  scriptTag.src = typeof options.url === 'string' ? options.url : options.url.src;
  scriptTag.async = false;

  // @ts-ignore
  scriptTag.onreadystatechange = scriptTag.onload = function() {
    // this code handles two scenarios, whether called by onload or onreadystatechange
    // @ts-ignore
    const state = scriptTag.readyState;

    clearTimeout(timeoutIdx);

    // @ts-ignore
    if (!callback.done && (!state || /loaded|complete/.test(state))) {
      // @ts-ignore
      callback.done = true;
      callback();
      // @ts-ignore
      scriptTag.onreadystatechange = scriptTag.onload = null;
    }
  };

  document.body.appendChild(scriptTag);

  // You can't catch JSONP Errors, because it's handled by the script tag
  // one way is to use a timeout
  timeoutIdx = setTimeout(function() {
    // @ts-ignore
    callback.done = true;
    callback();
    // @ts-ignore
    scriptTag.onreadystatechange = scriptTag.onload = null;
  }, options.timeout);
}
